package tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_room_view

sealed class ChatRoomEvent {
    data class StartRecieveMsg(val onRecieveMsg: (String)->Unit): ChatRoomEvent()
    data class EndChatMsg(val expertUid:String): ChatRoomEvent()
    data object OnLogOutAgora: ChatRoomEvent()
    data class SendMsg(val msg:String,val peerId:String,val onError:(String)->Unit): ChatRoomEvent()
    data object GoToDashBoard: ChatRoomEvent()
    data class OnUserTyping(val expertUid: String,val isTyping:Boolean): ChatRoomEvent()
}